import localReducer from './localReducer';
import { useReducer } from 'react';
export default function useLocalReducer(defaultState){
  return useReducer(localReducer,defaultState||{});
}
